// extracted by mini-css-extract-plugin
export var center = "_3n-2";
export var clickableRow = "_3n-6";
export var hoverable = "_3n-4";
export var left = "_3n-1";
export var right = "_3n-3";
export var row = "_3n-0";
export var selectedRow = "_3n-5";